import { render, staticRenderFns } from "./COMScreen2.vue?vue&type=template&id=5f0793ae"
import script from "./COMScreen2.vue?vue&type=script&lang=js"
export * from "./COMScreen2.vue?vue&type=script&lang=js"
import style0 from "./COMScreen2.vue?vue&type=style&index=0&id=5f0793ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports